module.exports = __webpack_public_path__ + "static/media/Butcher.4b935f8e.jpg";